import React, { useState, useEffect } from "react";
import KnowtexEMSuggestion from "./KnowtexEMSuggestion";
import { calculateLevels } from "./emlevelsfcn";
import sendServerLogging from "../../../utils/sendServerLogging";
import userJSON from "../../../utils/userJSON";
export default function EMSection({
  isRationaleProvided,
  setIsRationaleProvided,
  mdm_selected,
  setMDMSelected,
  mdm_suggested,
  userRationale,
  setUserRationale,
  showRationale,
  setShowRationale,
  setFinalSelectedLevel,
  patient,
  setRecommendedLevel,
  setFinalSelectedTs,
  setMDMSelectedTs,
  encounterTime,
  setEncounterTime,
  status,
}) {
  const [activeButton, setActiveButton] = useState(null);
  const [showRecommendations, setShowRecommendations] = useState(false);
  const [levels, setLevels] = useState({});

  useEffect(() => {
    const lvls = calculateLevels(mdm_suggested);
    setLevels(lvls);
    // Store Knowtex's recommended numeric level in the parent:
    if (lvls.note) {
      setRecommendedLevel(lvls.note);
    }
  }, [mdm_suggested, setRecommendedLevel]);

  // This is the FIRST row of level buttons
  const handleClick = (selectedLevel) => {

    // server logging
      sendServerLogging({
        body: {
          ...userJSON(localStorage.getItem("userName")),
          event: "E&M_SELECTED_CODE_CLICKED",
          eventData: { "mrn": patient.mrn, "em_code": selectedLevel },
          patientId: patient.patient_id
        },
      });

    const timestampInSeconds = Math.floor(Date.now() / 1000);

    setActiveButton(selectedLevel);
    setMDMSelected(selectedLevel);
    setMDMSelectedTs(timestampInSeconds);

    // If user picks the same as recommended => skip second row, set final
    if (parseInt(selectedLevel) === parseInt(levels.note)) {
      setShowRecommendations(false);
      setShowRationale(false);
      setIsRationaleProvided(true);
      setFinalSelectedLevel(selectedLevel);
      setFinalSelectedTs(timestampInSeconds);
    } else {
      // If user picks a different level => reveal second row
      setShowRecommendations(true);
      setShowRationale(false);
      setIsRationaleProvided(false);
      //setFinalSelectedLevel(null);
      setFinalSelectedTs(null);
    }
  };

  let visitType = "";

  const getVisitType = (patientType) => {
    if (patient.patient_type === null || patient.patient_type === "new") {
      visitType = "Consultation";
    } else {
      visitType = "Follow Up";
    }

    return visitType;
  };

  return (
    <div className="flex flex-col">
      {/* Header row with E&M Codes title and Time field */}
      <div className="flex flex-row justify-between items-start mb-4">
        <div className="flex flex-col flex-1">
          <h1 className="text-accent1 text-xl font-medium mb-2">E&M Codes</h1>
          <h2 className="text-light-grey text-md font-medium mb-2">
            Visit Type: {getVisitType()}
          </h2>
        </div>
        
        {/* Time field aligned with E&M Codes header */}
        <div className="flex flex-col min-w-[300px]">
          <div className="mb-4">
            <label className="block text-accent1 text-sm font-medium mb-2">
              Total Encounter Time (minutes)
            </label>
            <input
              type="text"
              readOnly={status === "Locked"}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-ktx-green focus:border-transparent bg-secondary-grey text-black"
              value={Math.floor(encounterTime) || ""}
              onChange={(e) => setEncounterTime && setEncounterTime(e.target.value)}
              placeholder="Enter time in minutes"
            />
          </div>
        </div>
      </div>
      
      {/* E&M selection content */}
      <div className="flex flex-col">
        <h3 className="text-accent1 text-sm font-light italic mb-2">
          Select the level of service for this visit.
        </h3>
        <h3 className="text-accent1 text-sm font-semibold">Level:</h3>

        {/* FIRST row of level buttons */}
        <div className="flex flex-row gap-4">
          {[2, 3, 4, 5].map((number) => (
            <button
              key={number}
              onClick={() => handleClick(number)}
              className={`border-accent1 border rounded-md hover:bg-transparent-purple 
                hover:text-accent1 text-accent1 font-bold py-2 px-4 w-12 h-12 
                flex items-center justify-center ${
                  activeButton === number ? "bg-transparent-purple" : ""
                }`}
            >
              {number}
            </button>
          ))}
        </div>

        {/* If user picks a different level, show second row */}
        {showRecommendations && mdm_suggested && (
          <KnowtexEMSuggestion
            showRecommendations={showRecommendations}
            isRationaleProvided={isRationaleProvided}
            setIsRationaleProvided={setIsRationaleProvided}
            userRationale={userRationale}
            setUserRationale={setUserRationale}
            showRationale={showRationale}
            setShowRationale={setShowRationale}
            mdm_suggested={mdm_suggested}
            setFinalSelectedLevel={setFinalSelectedLevel}
            setFinalSelectedTs={setFinalSelectedTs}
            levels={levels}
            patient={patient}
          />
        )}
      </div>
    </div>
  );
}
